import { render } from "./senior.vue?vue&type=template&id=581b6cae&scoped=true"
import script from "./senior.vue?vue&type=script&lang=js"
export * from "./senior.vue?vue&type=script&lang=js"

import "./senior.vue?vue&type=style&index=0&id=581b6cae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581b6cae"]])

export default __exports__